import { render, staticRenderFns } from "./ReportCompetency.vue?vue&type=template&id=605171cf&scoped=true"
import script from "./ReportCompetency.vue?vue&type=script&lang=js"
export * from "./ReportCompetency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605171cf",
  null
  
)

export default component.exports